import { useState } from "react";
import { httpClient } from "./api/client";
import { logger } from "@/helpers/tslog";

export default function useFetchCurrencies() {
  const [currencyOptions, setCurrencyOptions] = useState<{ label: string; value: string }[]>([]);

  async function fetchCurrencies() {
    try {
      const response = await httpClient.get("/search/currency", {
        withCredentials: true,
      });

      const data: { label: string; value: string }[] = response.data.map((currency: string) => ({
        label: currency,
        value: currency,
      }));

      setCurrencyOptions(data);
    } catch (err) {
      logger.error("Error fetching currencies:", err);
    }
  }

  return { currencyOptions, fetchCurrencies };
}
